import styled from 'styled-components'
import { minmedia } from './media-queries'
import { black, white, bordergray, lightergray, darkgray, gold } from './colors'

// CONTENTS:
// Dropdown, DropdownItem
// BottomBarDropDown, BottomBarDropDownItem, BottomBarDropDownIconContainer,
// BottomBarName, BottomBarNext
// IconNavDropDown, IconNavDropDownItem, IconNavDropDownIconContainer

/* Desktop Header Dropdown */

export const Dropdown = styled.div`
  transition: all 0.5s;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0;
  transform: translateY(0);

  background: ${white};
  border: 1px solid ${bordergray};
  text-align: left;
  z-index: -1;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  box-shadow: inset 0px 11px 3px -10px rgba(0, 0, 0, 0.2);
`

export const DropdownItem = styled.div`
  border-bottom: 1px solid ${bordergray};
  width: 100%;

  &:last-child {
    border-bottom: 0;
    margin-bottom: 0;
  }

  a {
    transition: all 0.5s;
    padding: 1rem;
    font-size: 18px;
    color: ${black};
    background: ${props => (props.current ? '#EFEFEF' : 'none')};
    text-decoration: none;
    position: relative;
    display: block;
    width: 100%;
    white-space: nowrap;

    &:hover {
      background: ${lightergray};
    }
  }
`

/* BottomBarDropdown */

export const BottomBarDropDown = styled.div`
  transition: all 0.5s;
  width: 100%;
  position: absolute;
  left: ${props => (props.right ? 'auto' : '0')};
  right: ${props => (props.right ? '0' : 'auto')};
  bottom: ${props => (props.main ? '56px' : '0px')};
  background: ${lightergray};
  text-align: left;
  z-index: ${props => (props.z ? props.z : '-1')};
  opacity: 0;
  transform: translateY(100%);

  ${minmedia.medium`
    width: ${props => (props.child ? '100%' : '50%')};
  `} a {
    display: block;
    width: 100%;
    color: ${darkgray};
    text-decoration: none;
  }
`

export const BottomBarDropDownItem = styled.div`
  transition: all 0.5s;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1rem;
  font-size: 18px;
  border-bottom: 1px solid ${bordergray};

  &:hover {
    background: ${lightergray};
  }
`

export const BottomBarDropDownIconContainer = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  position: relative;
  margin-right: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${props => (props.black ? '#000' : '#ABA089')};
  }
`

export const BottomBarName = styled.div`
  font-size: 18px;
  font-weight: 400;
  padding: 1rem;
  border-bottom: 1px solid ${bordergray};
  width: 100%;

  ${minmedia.medium`
    font-size: 20px;
  `};
`

export const BottomBarNext = styled.div`
  width: 0.75rem;
  height: 0.75rem;
  margin-left: auto;
  fill: ${black};

  svg {
    width: 0.75rem;
    height: 0.75rem;
  }
`

/* IconNavDropdown */

export const IconNavDropDown = styled.div`
  transition: all 0.5s;
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0;
  transform: translateY(0);
  width: 270px;
  background: ${white};
  border: 1px solid ${bordergray};
  text-align: left;
  z-index: -1;
  border-bottom-left-radius: 0.25rem;
  box-shadow: inset 0px 11px 3px -10px rgba(0, 0, 0, 0.2);

  a {
    display: block;
    width: 100%;
    color: ${darkgray};
    text-decoration: none;

    &:last-child > div {
      border-bottom: 0;
    }
  }
`

export const IconNavDropDownItem = styled.div`
  transition: all 0.5s;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1rem;
  font-size: 18px;
  border-bottom: 1px solid ${bordergray};

  &:hover {
    background: ${lightergray};
  }
`

export const IconNavDropDownIconContainer = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  position: relative;
  margin-right: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${gold};
  }
`



// WEBPACK FOOTER //
// ./src/styles/defaults-header.js